module.exports = __webpack_public_path__ + "img/unique-approach-girl.fbd959bf.png";